/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 18.05.17.
 */

import React from "react";
import PropTypes from "prop-types";

import NavbarTop from "./NavbarTop";
import NavbarLeft from "./NavbarLeft";
import Notify from '../../containers/Notify';
import Footer from "./Footer";

class Main extends React.Component {
    static propTypes = {
        miniNavbar: PropTypes.bool,
        leftMenu: PropTypes.array.isRequired,
        person: PropTypes.object.isRequired,
        activeRole: PropTypes.object.isRequired,
        onToggleMiniNavbar: PropTypes.func,
        onLogout: PropTypes.func,
        onClickSwitchRole: PropTypes.func,
        onClickProfile: PropTypes.func,
    };

    static defaultProps = {
        miniNavbar: false
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    makeBreadcrumb() {
        let navStack = [];
        React.Children.forEach(this.props.children, child => {
            if (child.type && child.type.getPageStyle && typeof child.type.getPageStyle === "function") {
                navStack.push(child);
                // this.setPageStyle(callback, child.type.getPageStyle());
            }
        });
    }


    render() {
        return (
            <div id="wrapper">
                <NavbarLeft
                    miniNavbar={this.props.miniNavbar}
                    leftMenu={this.props.leftMenu}
                    person={this.props.person}
                    activeRole={this.props.activeRole}
                    onClickSwitchRole={this.props.onClickSwitchRole}
                    onClickProfile={this.props.onClickProfile}
                    onClickLogout={this.props.onLogout} />
                <div id="page-wrapper" className="gray-bg dashbard-1">
                    <div className="row border-bottom">
                        <NavbarTop
                            onClickMinimize={this.props.onToggleMiniNavbar}
                            onLogout={this.props.onLogout}/>
                    </div>
                    {this.props.children}
                    <Notify/>
                    <Footer/>
                </div>
            </div>
        );
    }
}

export default Main;
